// ---------------------------------------------------------------------------
// Resolves the base URL for Databricks REST API calls.
//
// Requests go through the app's server-side proxy at /api/databricks, which
// forwards to VITE_DATABRICKS_HOST. This avoids browser CORS restrictions.
// In local development the Vite dev server provides the proxy; in production
// the app-service Express server provides it.
// ---------------------------------------------------------------------------
export function getDatabricksBaseUrl(): string {
  return '/api/databricks'
}
